import request from "@/utils/request";

/**
 * 获取楼层列表
 */
export function getFloorList(data) {
    return request.get("/floor_list", data);
}

export function getFloorProducts(cate_id) {
    return request.get('/floor_products', cate_id)
}

/**
 * 获取banner列表
 */
export function getBannerList() {
    return request.get("/banner_list", { login: false });
}
